import React, { Fragment } from "react";
import NavbarEvent from "../../components/NavbarEvent";
// import PageEvent from "../../components/PageEvent";
import Celebration from "../../components/Celebration";
import Scrollbar from "../../components/scrollbar";
import Footer from "../../components/footer";

const CelebrationPage = () => {
  return (
    <Fragment>
      <NavbarEvent hclass={"wpo-header-style-event"} topbarBlock={"topbar-block"} />
      {/* <PageEvent pagesub={"Blog"} /> */}
      <Celebration blLeft={"d-none"} blRight={"col-lg-10 offset-lg-1"} />
      <Scrollbar />
      <Footer />
    </Fragment>
  );
};
export default CelebrationPage;
